// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__Nv7aK","Container":"style_Container__78WFj","btns":"style_btns__DgPmK"};